import styled from 'styled-components';

export const Container = styled.div`
  min-width: 98vw;
  /* min-height: 95vh; */
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 5vh;
  padding-left: 34px;

  @media (max-width: 680px) {
    margin-top: 16px;
  }
`;

export const ContentOrders = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 97%;
  overflow-x: auto;
  padding-right: 10px;

  @media (max-width: 680px) {
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: auto;
    max-height: 40vh;
  }
`;

export const ContentSpinner = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 12vh;
`;

export const ContentCategories = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 100%;
  justify-content: center;

  @media (max-width: 380px) {
    justify-content: center;
  }
`;

export const ContentTasks = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 100%;
`;

export const ContentSubtitle = styled.div`
  margin-top: 30px;
  display: flex;
  flex: 1;
  font-family: Raleway;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 30px;
  color: #565656;
  margin-bottom: 5vh;
  @media (max-width: 680px) {
    font-size: 16px;
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  width: 90vw;
`;

export const WelcomeUser = styled.div`
  display: flex;
  flex: 1;
  font-family: Raleway;
  font-style: normal;
  font-weight: normal;
  font-size: 30px;
  line-height: 23px;
  color: #565656;
  margin-top: 3vh;

  span {
    font-weight: 800;
    color: #ff7465;
  }

  @media (max-width: 680px) {
    margin-top: 30px;
    font-size: 24px;
    margin-bottom: ${props => (props.marginBottom ? '25px' : '0')};
  }
`;
